import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";

import NavigationBar from "../DesktopNav";
import Header from "./TopBar";
import AdminSideNav from "../Admin/AdminSideNav";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userData = JSON.parse(sessionStorage.getItem("user"));
  const userID = userData?.userid;

  const isAdminRoute = location.pathname.toLowerCase().startsWith("/admin");

  // UUID Generator
  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );

  // Generate sessionID after login
  useEffect(() => {
    if (!userID) return;

    let storedSessionID = sessionStorage.getItem("sessionID");

    if (!storedSessionID) {
      storedSessionID = generateUUID();
      sessionStorage.setItem("sessionID", storedSessionID);
    }
  }, [userID]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <div className="flex h-screen overflow-hidden bg-[#dfedff36]">
      {/* LEFT SIDEBAR */}
      {isAdminRoute ? (
        <AdminSideNav
          Admin={true}
          logout={handleLogout}
          NameAdmin={userData?.username || "Admin"}
          AdminRole={userData?.role || "Super Admin"}
        />
      ) : (
        <NavigationBar handleLogout={handleLogout} userID={userID} />
      )}

      {/* RIGHT SIDE */}
      <div
        className={`flex min-w-0 flex-1 flex-col ${
          isAdminRoute ? "lg:ml-[270px]" : ""
        }`}
      >
        {!isAdminRoute && <Header />}

        {/* CONTENT */}
        <div
          className={`flex-1 overflow-auto bg-[#dfedff36] ${
            isAdminRoute ? "pt-[64px] lg:pt-0" : ""
          }`}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;